/**
 * Reads a JWT's payload. Tokens are base64url and UTF-8: plain atob() rejects "-" and "_", and it
 * returns bytes as Latin-1 characters, which garbles non-English names such as Bangla ones.
 */
export const decodeTokenPayload = (token: string): Record<string, unknown> | null => {
    const part = token.split('.')[1];
    if (!part) return null;
    try {
        const base64 = part.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(part.length / 4) * 4, '=');
        // Percent-encode each byte and let decodeURIComponent assemble the UTF-8 characters.
        const utf8 = Array.from(atob(base64), c => `%${c.charCodeAt(0).toString(16).padStart(2, '0')}`).join('');
        return JSON.parse(decodeURIComponent(utf8));
    } catch {
        return null;
    }
};
